<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="confirmationCodeForm">
  <profile-pds-p-heading
    id="requestAndInsertHeadline"
    p-heading
    class="profile:mt-fluid-md profile:sm:mt-0"
    [tag]="'h4'"
    [size]="'medium'"
    [attr.tabindex]="'-1'"
    weight="bold"
  >
    {{ 'pidpaw.editPhone.headline.verification.requestAndInsert' | translate }}
  </profile-pds-p-heading>

  <profile-pds-p-text p-text>
    {{ 'pidpaw.editPhone.text.verification.insertCode' | translate }}
  </profile-pds-p-text>

  <profile-pds-p-heading p-heading class="profile:mt-fluid-md" [tag]="'h4'" [size]="'medium'" weight="bold">
    <span dir="ltr">{{ phoneNumberBeingVerified.number | formattedNumber: country }}</span>
  </profile-pds-p-heading>

  <div class="profile:mt-fluid-md">
    <div>
      <profile-pds-p-pin-code
        p-pin-code
        [length]="5"
        [label]="'pidpaw.editPhone.verification.pinCode.label' | translate"
        [hideLabel]="true"
        (change)="validateConfirmationCode($event)"
        [loading]="confirmationCodeStatus === ConfirmationCodeStatus.CODE_STATUS_VALIDATION_PENDING"
        [disabled]="isDisabled"
        [state]="messageState"
        [message]="messages[0]"
        #smsCode
      ></profile-pds-p-pin-code>
    </div>
  </div>

  <profile-pds-p-text p-text class="profile:mt-fluid-md">
    {{ 'pidpaw.editPhone.label.verification.noSMSReceived' | translate }}

    <pidx-timer-label
      [timer]="waitingTime"
      [requestCodeTimerLabel]="'pidpaw.editPhone.label.verification.requestCodeAgain' | translate"
      [waitingTimerLabelText]="'pidpaw.editPhone.text.verification.waitingTimerMessage' | translate"
      [tooltipInfoText]="'pidpaw.editPhone.tooltip.verification.info' | translate"
      (clickedTimerEvent)="requestConfirmationCode()"
      [myprofileUiTrack]="{
        clickElementType: 'button',
        clickElementId: 'phonenumber',
        clickElementName: 'request_verification_code',
      }"
    ></pidx-timer-label>
  </profile-pds-p-text>

  <profile-pds-p-button
    [aria]="{ 'aria-label': ('pidpaw.editPhone.button.cancel.aria' | translate) }"
    p-button
    variant="secondary"
    (click)="cancel()"
    icon="close"
    class="profile:mt-fluid-md"
    data-protractor-id="phone-widget-verification-cancel-button"
    [myprofileUiTrack]="{
      clickElementType: 'button',
      clickElementId: 'phonenumber',
      clickElementName: 'cancel',
    }"
    >{{ 'pidpaw.editPhone.button.cancel.label' | translate }}</profile-pds-p-button
  >
</div>
